if (!customElements.get("collection-load-more")) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();
      let idSection = this.getAttribute("id");

      this.listContainer = this.querySelector(
        `#Collection-product-grid--${idSection}`
      );
      this.buttonLoad = this.querySelector(`#Loadmore--${idSection}`);

      this.itemsPerClick = 4; // Number of items to show per click
      this.visibleItems = this.getAttribute('data-itemShow') ? parseInt(this.getAttribute('data-itemShow')) : 4; // Initially shown items
      this.items = this.listContainer.querySelectorAll(".product-item");

      this.buttonLoad.addEventListener("click", () => {
        this.loadMore();
      });

      this.showItems();
    }

    showItems = () => {
      for (let i = 0; i < this.visibleItems; i++) {
        if (this.items[i]) {
          this.items[i].style.display = "block";
        }
      }
    };

    loadMore = () => {
      let hiddenItems = Array.from(this.items).filter(
        (item) => item.style.display === "none"
      );

      for (let i = 0; i < this.itemsPerClick; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].style.display = "block";
        }
      }

      // Hide button when all items are shown
      if (
        Array.from(this.items).every((item) => item.style.display === "block")
      ) {
        this.buttonLoad.style.display = "none";
      }
    };
  }

  customElements.define("collection-load-more", CollectionLoadMore);
}
